import { Component } from '@angular/core';
import { soundpostCurrencyEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Currencies') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostcurrency-form',
    templateUrl: './soundpostcurrency.form.component.html'
})
export class soundpostCurrencyFormComponent extends BaseFormComponent {
    public record!: soundpostCurrencyEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'payments', sectionName: 'Payments', isExpanded: false },
            { sectionKey: 'accountingSchedules', sectionName: 'Accounting Schedules', isExpanded: false },
            { sectionKey: 'trialBalances', sectionName: 'Trial Balances', isExpanded: false },
            { sectionKey: 'accountingEntries', sectionName: 'Accounting Entries', isExpanded: false },
            { sectionKey: 'accountingEntryLines', sectionName: 'Accounting Entry Lines', isExpanded: false },
            { sectionKey: 'orders', sectionName: 'Orders', isExpanded: false },
            { sectionKey: 'exchangeRatesBaseCurrencyCode', sectionName: 'Exchange Rates (Base Currency Code)', isExpanded: false },
            { sectionKey: 'exchangeRatesQuoteCurrencyCode', sectionName: 'Exchange Rates (Quote Currency Code)', isExpanded: false },
            { sectionKey: 'postingGroups', sectionName: 'Posting Groups', isExpanded: false }
        ]);
    }
}

